import { injectable } from "inversify";
import { TableRepo } from "../table.repo";
import { NotificationModel, SendNotificationToUsersRequest, SendNotificationByListRequest } from "@/core/models/notification.model";

@injectable()
export class NotificationRepo extends TableRepo<NotificationModel> {
    constructor() {
        super("/api/Notification");
    }

    async sendToMultipleUsers(request: SendNotificationToUsersRequest): Promise<boolean> {
        try {
            const response = await this.apiRepo.post(`${this.basepath}/send-to-users-by-id?v=1.0`, {
                title: request.title,
                content: request.content,
                pushData: request.pushData || "",
                pushBadgeCount: request.pushBadgeCount || 0,
                onlyAppNotification: request.onlyAppNotification !== undefined ? request.onlyAppNotification : true,
                userIds: request.userIds
            });
            if (response?.code === '00') {
                return true;
            }
            return false;
        } catch (err) {
            console.log(err);
            return false;
        }
    }

    async sendByList(request: SendNotificationByListRequest): Promise<boolean> {
        try {
            const response = await this.apiRepo.post(`${this.basepath}/send-multi-user-by-list`, {
                ListId: request.listId,
                Title: request.title,
                Content: request.content,
                Data: request.data
            });
            if (response?.code === '00') {
                return true;
            }
            return false;
        } catch (err) {
            console.log(err);
            return false;
        }
    }
}

